var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.895431 0 2V7.33333C0 8.4379 0.895431 9.33333 2 9.33333H7.33333C8.4379 9.33333 9.33333 8.4379 9.33333 7.33333V2C9.33333 0.895431 8.4379 0 7.33333 0H2Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0C11.5621 0 10.6667 0.895431 10.6667 2V7.33333C10.6667 8.4379 11.5621 9.33333 12.6667 9.33333H18C19.1046 9.33333 20 8.4379 20 7.33333V2C20 0.895431 19.1046 0 18 0H12.6667Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.6667C0.895431 10.6667 0 11.5621 0 12.6667V18C0 19.1046 0.895431 20 2 20H7.33333C8.4379 20 9.33333 19.1046 9.33333 18V12.6667C9.33333 11.5621 8.4379 10.6667 7.33333 10.6667H2Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.6667C11.5621 10.6667 10.6667 11.5621 10.6667 12.6667V18C10.6667 19.1046 11.5621 20 12.6667 20H18C19.1046 20 20 19.1046 20 18V12.6667C20 11.5621 19.1046 10.6667 18 10.6667H12.6667Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaces);
export default __webpack_public_path__ + "static/media/spaces.79ace6564e4afcf3ff5e42a4184a502d.svg";
export { ForwardRef as ReactComponent };